import React from "react";
import { Link } from "react-router-dom";
import PublicLayout from "./PublicLayout";
import { LEGAL_EFFECTIVE_DATE } from "../lib/legalContent";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

function Body({ items }) {
  return items.map((b, i) =>
    typeof b === "string" ? (
      <p key={i} className="mt-3 text-base leading-relaxed text-ink-700">{b}</p>
    ) : (
      <ul key={i} className="mt-3 list-disc space-y-1.5 pl-6 text-base leading-relaxed text-ink-700">
        {b.list.map((li) => <li key={li}>{li}</li>)}
      </ul>
    )
  );
}

/** Public, unauthenticated legal page (Privacy Policy / Terms of Service). */
export default function LegalDocument({ doc, testid, otherLink }) {
  return (
    <PublicLayout>
      <article className="container-page max-w-3xl py-14 md:py-20" data-testid={testid}>
        <p className="label-caps">Legal</p>
        <h1 className="mt-2 font-heading text-3xl font-bold text-ink-900 sm:text-4xl" data-testid={`${testid}-title`}>
          {doc.title}
        </h1>
        <p className="mt-2 text-sm font-semibold text-ink-500" data-testid={`${testid}-effective-date`}>
          Effective Date: {LEGAL_EFFECTIVE_DATE}
        </p>
        <Body items={doc.intro} />
        {doc.sections.map((s) => (
          <section key={s.h} id={slug(s.h)} className="mt-10 scroll-mt-24">
            <h2 className="font-heading text-xl font-bold text-ink-900">{s.h}</h2>
            <Body items={s.body} />
          </section>
        ))}
        <section className="mt-10" data-testid={`${testid}-contact`}>
          <h2 className="font-heading text-xl font-bold text-ink-900">Contact</h2>
          <p className="mt-3 text-base text-ink-700">{doc.contactIntro}</p>
          <address className="mt-3 not-italic text-base leading-relaxed text-ink-900">
            Rayven Tech LLC<br />
            Squad Fee<br />
            <a href="mailto:support@squadfee.com" className="font-semibold text-brand hover:underline">support@squadfee.com</a>
          </address>
        </section>
        <p className="mt-12 border-t border-ink-100 pt-6 text-sm text-ink-500">
          See also: <Link to={otherLink.to} className="font-semibold text-brand hover:underline" data-testid={`${testid}-other-link`}>{otherLink.label}</Link>
        </p>
      </article>
    </PublicLayout>
  );
}
